import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash === '') {
            window.scrollTo(0, 0);
        } else if (document.getElementById(hash)) {
            window.scrollto(0, document.getElementById(hash).offsetTop);
        }
    }, [pathname]);

    return null;
};